import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  // Allow large uploads
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
  timeout: 180000, // 3 minutes default timeout
});

// Add token and ensure correct URL format
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Remove trailing slash if present (FastAPI redirects with slash to without)
  if (config.url && config.url.endsWith('/') && !config.url.includes('?')) {
    config.url = config.url.slice(0, -1);
  }
  
  return config;
});

// Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Las rutas públicas del club manejan su propia sesión (X-Club-Token)
      if (error.config?.url?.includes("/club/")) {
        return Promise.reject(error);
      }
      // Check if this is an embajador session
      const embajador = localStorage.getItem("embajador");
      const currentPath = window.location.pathname;
      
      // If embajador session exists and we're on an embajador route, redirect to embajador login
      if (embajador || currentPath.startsWith("/embajador")) {
        localStorage.removeItem("token");
        localStorage.removeItem("embajador");
        if (!currentPath.includes("/embajador/login") && !currentPath.includes("/embajador/registro")) {
          window.location.href = "/embajador/login";
        }
      } else {
        // Regular user - redirect to main login
        localStorage.removeItem("token");
        if (currentPath !== "/login" && currentPath !== "/") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
